import { render, staticRenderFns } from "./CoursePreview.vue?vue&type=template&id=a241a332&scoped=true&"
import script from "./CoursePreview.vue?vue&type=script&lang=js&"
export * from "./CoursePreview.vue?vue&type=script&lang=js&"
import style0 from "./CoursePreview.vue?vue&type=style&index=0&id=a241a332&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a241a332",
  null
  
)

/* custom blocks */
import block0 from "./CoursePreview.vue?vue&type=custom&index=0&blockType=translations"
if (typeof block0 === 'function') block0(component)

export default component.exports